import { render, staticRenderFns } from "./DownloadReports.vue?vue&type=template&id=6a9f09f3&"
import script from "./DownloadReports.vue?vue&type=script&lang=js&"
export * from "./DownloadReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports